/* ==========================================================================
   SERPROMAQ - INTEGRACIÓN FLOTANTE DE ATENCIÓN POR WHATSAPP OFICIAL
   ========================================================================== */

const DEFAULT_PHONE = '573168275829';

export function initWhatsAppWidget() {
  const whatsappBubble = document.getElementById('whatsappBubble');
  const whatsappTooltip = document.getElementById('whatsappTooltip');
  const whatsappTooltipText = document.getElementById('whatsappTooltipText');

  if (!whatsappBubble) return;

  // Mensajes contextuales según la sección visualizada
  const messagesBySection = {
    'inicio': 'Hola 👋 ¿Deseas cotizar o tienes alguna consulta?',
    'pilares': 'Hola 🛠️ ¿Requieres mantenimiento preventivo o repuestos?',
    'servicios': 'Hola 🚜 ¿Deseas cotizar maquinaria o montacargas?',
    'talento': 'Hola 👷 ¿Deseas conocer nuestras vacantes laborales?',
    'portal-postulacion': 'Hola 📄 ¿Deseas postular tu perfil o enviar CV?',
    'nosotros': 'Hola 🏭 ¿Quieres conocer nuestra cobertura técnica?',
    'testimonios': 'Hola ⭐ Conoce nuestros clientes o pide tu cotización.',
    'contacto': 'Hola 📞 Estamos listos para atenderte por WhatsApp.'
  };

  const getWhatsAppUrl = () => {
    // Detectar sección activa
    let activeId = window.location.hash.replace('#', '');

    if (!activeId || !messagesBySection[activeId]) {
      const sections = document.querySelectorAll('section[id]');
      const scrollY = window.pageYOffset || document.documentElement.scrollTop;
      sections.forEach(current => {
        const sectionHeight = current.offsetHeight;
        const sectionTop = current.offsetTop - 200;
        if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
          activeId = current.getAttribute('id');
        }
      });
    }

    let messageText = 'Hola SERPROMAQ 👋, me gustaría solicitar una cotización y recibir más información sobre sus servicios y montacargas.';

    if (activeId === 'servicios') {
      messageText = 'Hola SERPROMAQ 👋, me gustaría cotizar maquinaria industrial del catálogo (venta / alquiler).';
    } else if (activeId === 'pilares') {
      messageText = 'Hola SERPROMAQ 👋, requiero información y cotización sobre mantenimiento de montacargas y repuestos.';
    } else if (activeId === 'talento' || activeId === 'portal-postulacion') {
      messageText = 'Hola SERPROMAQ 👋, deseo información sobre las vacantes técnicas y oportunidades de trabajo.';
    } else if (activeId === 'contacto') {
      messageText = 'Hola SERPROMAQ 👋, quisiera ponerme en contacto directo con un asesor comercial.';
    }

    return `https://wa.me/${DEFAULT_PHONE}?text=${encodeURIComponent(messageText)}`;
  };

  // Abrir chat comercial de WhatsApp en nueva pestaña
  const handleOpenWhatsApp = (e) => {
    if (e) e.preventDefault();
    const url = getWhatsAppUrl();
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  whatsappBubble.addEventListener('click', handleOpenWhatsApp);
  whatsappTooltip?.addEventListener('click', handleOpenWhatsApp);

  // Actualizar tooltip según posición de scroll
  window.addEventListener('scroll', () => {
    const sections = document.querySelectorAll('section[id]');
    const scrollY = window.pageYOffset || document.documentElement.scrollTop;

    sections.forEach(current => {
      const sectionHeight = current.offsetHeight;
      const sectionTop = current.offsetTop - 200;
      const sectionId = current.getAttribute('id');

      if (scrollY > sectionTop && scrollY <= sectionTop + sectionHeight) {
        if (messagesBySection[sectionId] && whatsappTooltipText) {
          whatsappTooltipText.textContent = messagesBySection[sectionId];
        }
      }
    });
  }, { passive: true });
}
